import { render, staticRenderFns } from "./PsInput.vue?vue&type=template&id=dc06bad8&scoped=true&"
import script from "./PsInput.vue?vue&type=script&lang=js&"
export * from "./PsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc06bad8",
  null
  
)

export default component.exports